import { render, staticRenderFns } from "./OrderIncentive.vue?vue&type=template&id=4f496ec8&scoped=true"
import script from "./OrderIncentive.vue?vue&type=script&lang=js"
export * from "./OrderIncentive.vue?vue&type=script&lang=js"
import style0 from "./OrderIncentive.vue?vue&type=style&index=0&id=4f496ec8&prod&scoped=true&lang=css"
import style1 from "./OrderIncentive.vue?vue&type=style&index=1&id=4f496ec8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f496ec8",
  null
  
)

export default component.exports